import {
  ApolloClient,
  InMemoryCache,
  makeVar,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { LOCALSTORAGE_TOKEN } from "./contants";

const token = localStorage.getItem(LOCALSTORAGE_TOKEN);

export const isLoggedInVar = makeVar(Boolean(token));
export const authTokenVar = makeVar(token);
export const godModeVar = makeVar(false);
export const adminTokenVar = makeVar("");

// postgres://fvhsnyqlawxaze:7fb2f822d30ead29bded5ac6dbbc36b07cd93db44ce85a4463d17ca1572daaff@ec2-54-195-144-105.eu-west-1.compute.amazonaws.com:5432/dde50lrq5aftip
// export const url = "http://192.168.1.56:5000"
// export const url = "http://192.168.1.117";
// export const url = "http://192.168.0.122";
// export const url = "http://localhost";
// export const url = "http://192.168.1.162";
export const url = "https://scalance.cloud";
export const uri = url + "/graphql";
// const uri = "http://192.168.1.156:4000/graphql"

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      "x-jwt": authTokenVar() || null,
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),

  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          users: {
            // Don't cache separate results based on
            // any of this field's arguments.
            keyArgs: ["where", ["search", "role", "roles"]],
            // Concatenate the incoming list items with
            // the existing list items.
            merge(existing = {}, incoming, { args }): any {
              return {
                ...incoming,
                results: [...(existing.results || []), ...incoming.results],
              };
            },
          },
          products: {
            keyArgs: [
              "where",
              "siteId",
              "search",
              "priceOnly",
              "orderByCreatedAt",
              "orderByPrice",
              "orderByQuantity",
              "limit",
            ],
            merge(existing = { results: [] }, incoming) {
              // Combine existing and incoming results
              const combinedResults = [
                ...existing.results,
                ...incoming.results,
              ];

              // Deduplicate results using Set and JSON.stringify
              const mergedResults = Array.from(
                // @ts-ignore
                new Set(combinedResults.map(JSON.stringify))
                // @ts-ignore
              ).map(JSON.parse);

              return {
                ...incoming,
                results: mergedResults,
              };
            },
          },
          references: {
            keyArgs: ["where", "userId", "search", "limit"],
            merge(existing = { results: [] }, incoming) {
              // Combine existing and incoming results
              const combinedResults = [
                ...existing.results,
                ...incoming.results,
              ];

              // Deduplicate results using Set and JSON.stringify
              const mergedResults = Array.from(
                // @ts-ignore
                new Set(combinedResults.map(JSON.stringify))
                // @ts-ignore
              ).map(JSON.parse);

              return {
                ...incoming,
                results: mergedResults,
              };
            },
          },
          sites: {
            // Don't cache separate results based on
            // any of this field's arguments.
            keyArgs: ["where", "search", "limit"],

            // Concatenate the incoming list items with
            // the existing list items.
            merge(existing = {}, incoming, { args }): any {
              let array = [...(existing.results || []), ...incoming.results];
              //@ts-ignore
              const results = Array.from(
                // @ts-ignore
                new Set(array.map(JSON.stringify))
                // @ts-ignore
              ).map(JSON.parse);

              return {
                ...incoming,
                results,
              };
            },
          },

          scans: {
            // Don't cache separate results based on
            // any of this field's arguments.
            keyArgs: [
              "where",
              "limit",
              [
                "search",
                "productId",
                "productIds",
                "siteId",

                "orderByCa",
                "orderByPrice",
                "orderByPriceVariation",
                "orderByQuantity",
                "orderByQuantityVariation",
                "orderByCreatedAt",

                "start",
                "end",
              ],
            ],

            // Concatenate the incoming list items with
            // the existing list items.
            merge(existing = {}, incoming, { args }): any {
              let array = [...(existing.results || []), ...incoming.results];
              //@ts-ignore
              const results = Array.from(
                // @ts-ignore
                new Set(array.map(JSON.stringify))
                // @ts-ignore
              ).map(JSON.parse);

              return {
                ...incoming,
                results,
              };
              // return [...existing, ...incoming];
            },
          },

          changelogs: {
            // Don't cache separate results based on
            // any of this field's arguments.
            keyArgs: ["where", ["userId", "database", "event"]],
            // Concatenate the incoming list items with
            // the existing list items.
            merge(existing = {}, incoming, { args }): any {
              return {
                ...incoming,
                results: [...(existing.results || []), ...incoming.results],
              };
            },
          },

          bestSellingSiteProducts: {
            // Utiliser `keyArgs` pour spécifier que chaque combinaison de `siteId`, `where`, etc. est unique
            keyArgs: ["siteId", "where", "groupBy", "orderBy"],

            // Modifier la stratégie de merge pour remplacer les anciens résultats par les nouveaux
            merge(existing = {}, incoming, { args }) {
              // Si l'offset est zéro, on considère que c'est un nouveau jeu de résultats et on remplace l'existant
              if (args?.offset === 0) {
                return incoming;
              }

              // Sinon, on concatène avec les résultats existants
              return {
                ...incoming,
                results: [...(existing.results || []), ...incoming.results],
              };
            },
          },

          isLoggedIn: {
            read() {
              return isLoggedInVar();
            },
          },

          token: {
            read() {
              return authTokenVar();
            },
          },

          godMode: {
            read() {
              return godModeVar();
            },
          },
        },
      },
    },
  }),
});

//  "search",
//                 "createdAt",
//                 "siteId",
//                 "orderByCreatedAt",
//                 "orderByPrice",
//                 "orderByQuantity",
//                 "orderByCa",

//                 "productId",

//                 "price",
//                 "priceVariation",
//                 "orderByPriceVariation",

//                 "quantity",
//                 "quantityVariation",
//                 "orderByQuantityVariation",

//                 "start",
//                 "end",
